;(function () {
  'use strict';

  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  function initVideoSwipers(container) {
    var sections = container ? [container] : document.querySelectorAll('.video-container');

    Array.prototype.forEach.call(sections, function (section) {
      var swipers = section.querySelectorAll('.swiper');

      Array.prototype.forEach.call(swipers, function (swiperEl) {
        var paginationEl = swiperEl.querySelector('.pagination');
        var nextEl = swiperEl.querySelector('.next');

        var swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          speed: 300,
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          navigation: {
            nextEl: nextEl,
          },
        });

        var videos = swiperEl.querySelectorAll('video');

        function pauseAllVideos() {
          Array.prototype.forEach.call(videos, function (video) {
            video.pause();
            video.currentTime = 0;
          });
        }

        // CSS media queries handle .hide_mobile / .hide_desktop visibility.
        // We just return the right video element based on device detection.
        function getActiveVideo(slide) {
          if (!slide) return null;
          if (isMobile) {
            return slide.querySelector('.hide_desktop video');
          } else {
            return slide.querySelector('.hide_mobile video');
          }
        }

        function playCurrentVideo() {
          var currentSlide = swiperInstance.slides[swiperInstance.activeIndex];
          if (!currentSlide) return;

          // Stop hidden videos from downloading — set preload=none on irrelevant ones
          Array.prototype.forEach.call(currentSlide.querySelectorAll('video'), function (v) {
            var parent = v.parentElement;
            if (!parent) return;
            var isHiddenOnMobile = parent.classList.contains('hide_mobile') && isMobile;
            var isHiddenOnDesktop = parent.classList.contains('hide_desktop') && !isMobile;
            if (isHiddenOnMobile || isHiddenOnDesktop) {
              v.preload = 'none';
            }
          });

          var video = getActiveVideo(currentSlide);
          if (!video) return;

          video.play().catch(function (err) {
            console.warn('Autoplay failed', err);
          });
          video.onended = function () {
            swiperInstance.slideNext();
          };
        }

        // Play the first video
        playCurrentVideo();

        // Switch video on slide change
        swiperInstance.on('slideChange', function () {
          pauseAllVideos();
          setTimeout(playCurrentVideo, 300);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideoSwipers();

    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId) {
        var loadedSection = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
        if (loadedSection) {
          initVideoSwipers(loadedSection.closest('.video-container') || loadedSection);
        }
      }
    });
  });
})();
